import { Space, Switch } from "antd";
import { useEffect } from "react";
import { useAppSelector } from "../../../../app/store";
import ConfirmModal from "../../../../components/ui/ConfirmModal";
import { useGetBusinessDataQuery } from "../../../../features/employee/employeeApi";
import { useUpdateVisitSettingMutation } from "../../../../features/tracking/trackingApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";

export default function VisitSettings() {
  const { open, handleOpen, handleClose } = useModal<boolean, "CONFIRM">();
  const [
    updateVisitSetting,
    {
      isLoading: isUpdateLoading,
      isSuccess: isUpdateSuccess,
      isError: isUpdateError,
      error: updateError,
    },
  ] = useUpdateVisitSettingMutation();
  const { authInfo } = useAppSelector((state) => state.auth);
  const {
    data: businessData,
    isError: isBusinessError,
    error: businessError,
    isLoading: isBusinessLoading,
  } = useGetBusinessDataQuery(authInfo?.business_id?.toString() || "", {
    skip: !authInfo?.business_id,
  });

  useError(isUpdateError, updateError, "Employee visit update fail");
  useError(isBusinessError, businessError, "Get business data fail");

  const switchValue = businessData?.data?.business?.is_enable_employee_visit;

  const showInfoText = (val: boolean) => {
    if (val) {
      return "Enabling this feature will let you live track your employee.";
    } else {
      return "If you disable this feature, you will not be able to live track your employee.";
    }
  };

  const handleConfirmBtnClick = () => {
    updateVisitSetting({
      id: authInfo?.business_id,
      data: {
        is_enable_employee_visit: Number(open.data),
      },
    });
  };

  useEffect(() => {
    if (isUpdateSuccess) {
      toast(
        "success",
        `Employee visit ${
          switchValue ? "deactivated" : "activated"
        } successfully`
      );

      handleClose();
    }

    if (isUpdateError) {
      toast("error", "Update fail");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateSuccess, isUpdateError]);

  return (
    <SidebarLayout title="Visit Settings">
      {open?.type === "CONFIRM" && (
        <ConfirmModal
          open={open?.open}
          handleOk={handleConfirmBtnClick}
          handleClose={handleClose}
          okText="Confirm"
          confirmTitle={"Confirmation"}
          questionText={`${showInfoText(open.data || false)}`}
          okLoading={isUpdateLoading}
        />
      )}

      <div className="bg-white rounded-md border border-extra-light p-6">
        <h3 className="text-header text-[22px] font-semibold mb-6">
          Employee Visit
        </h3>
        <Space className="w-full" size={24}>
          <h5 className="text-header text-base font-medium">Employee Visit:</h5>
          <div className="flex items-center gap-1">
            <Switch
              checked={Boolean(switchValue)}
              onChange={(e) => handleOpen({ type: "CONFIRM", data: e })}
              disabled={isBusinessLoading}
            />
            <div className="text-extra-gray text-sm">
              <span className="text-header font-medium">
                {switchValue ? "Activate" : "De-activate"}{" "}
              </span>
              - <span>{showInfoText(!Boolean(switchValue))}</span>
            </div>
          </div>
        </Space>
      </div>
    </SidebarLayout>
  );
}
